export interface StatItem {
  value: number;
  suffix: string;
  label: string;
}

export const stats: StatItem[] = [
  { value: 7, suffix: '+', label: 'Database Connectors' },
  { value: 5, suffix: '', label: 'AI Providers Built In' },
  { value: 8, suffix: '+', label: 'Visualization Types' },
  { value: 248, suffix: '+', label: 'Automated Tests' },
];
